module.exports = __webpack_public_path__ + "static/media/documents.01992b03.svg";